import { motion } from "framer-motion";

export default function OurStory() {
  return (
    <section id="story" data-testid="story-section" className="py-20 md:py-24 relative warm-section-alt">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2a9d8f] mb-4">Our Story</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2d2926] mb-6" style={{ fontFamily: 'Fraunces, serif' }}>
              From Observation to <span className="gradient-text">Action</span>
            </h2>
            <div className="space-y-4 text-base text-[#5c564e] leading-relaxed">
              <p>We started with a simple observation — while large enterprises were rapidly adopting AI, millions of growing businesses were being left behind. Not because they didn't need AI, but because it felt too complex, too expensive, and too distant.</p>
              <p>After years of working in high-impact roles and seeing technology transform businesses at scale, we made a bold decision — to step away from comfort and build something meaningful.</p>
              <p>We are not just consultants. We are <span className="text-[#2d2926] font-medium">builders, integrators, and long-term partners</span>. From hospitals to startups, from Tier 1 to Tier 3 markets — we believe AI should empower every business, everywhere.</p>
            </div>
            <p className="mt-6 text-lg text-[#2d2926] font-medium italic border-l-3 border-[#2a9d8f] pl-4" style={{ borderLeftWidth: 3 }}>
              "Because when businesses grow faster, smarter, and more efficiently — entire economies move forward."
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
